module.exports = __webpack_public_path__ + "b61fc7e6a171412feaa026121f0bfb76.jpg";